import { put } from 'redux-saga/effects'
import { updateChatFirebaseAction } from '../../handles/updateChatFirebaseAction'
import { update } from '../_http/chat'

export function* updateChatFirebaseSaga(action: ReturnType<typeof updateChatFirebaseAction.request>) {
  const { chatId, updateChat } = action.payload
  try {
    yield update(chatId, { ...updateChat, updatedAt: new Date().getTime() })
    yield put(updateChatFirebaseAction.success({ chatId, updateChat }))
  } catch (e) {
    yield put(updateChatFirebaseAction.failure(e))
  }
}
